import { FINISH_TXNS_SHOW_MORE } from './txns'
import { INFLATE as INFLATE_USER_TXNS } from './user_txns'
import { CREATE_DNW_TRANSACTION_SUCCESS } from './dnw_transaction'
import { getDisplayName } from '../../../shared/helpers/name_helpers'

export default function reducer(state = { map: {} }, action) {
  switch (action.type) {
    case FINISH_TXNS_SHOW_MORE: {
      const photosMappedToIds =
        action.payload.response && action.payload.response.photos
      const businessNamesMappedToIds =
        action.payload.response && action.payload.response.businessNames

      return {
        ...state,
        map: {
          ...mergeExtraInfoIntoContributers(
            state.map,
            photosMappedToIds,
            businessNamesMappedToIds
          ),
        },
      }
    }
    case INFLATE_USER_TXNS: {
      const newContributors = action.payload.list.reduce((map, txn) => {
        if (txn.contributor_id) {
          map[txn.contributor_id] = {
            full_name: txn.contributor_name,
            photo: txn.contributor_photo,
          }
        }
        return map
      }, {})
      return { ...state, map: { ...newContributors, ...state.map } }
    }
    case CREATE_DNW_TRANSACTION_SUCCESS: {
      const { id, ...rest } = action.payload.sender
      if (id) {
        return {
          ...state,
          map: {
            ...state.map,
            [id]: {
              ...rest,
            },
          },
        }
      }
      return state
    }
    default:
      return state
  }
}

function mergeExtraInfoIntoContributers(
  contributors,
  photosMappedToIds = {},
  businessNamesMappedToIds = {}
) {
  return Object.keys(contributors).reduce((newContributors, id) => {
    const contributor = contributors[id]
    newContributors[id] = {
      ...contributor,
      photo: contributor.photo || photosMappedToIds[id],
      full_name: getDisplayName(
        contributor.full_name,
        businessNamesMappedToIds,
        id
      ),
      has_business_name:
        !!businessNamesMappedToIds[id] || contributor.has_business_name
          ? true
          : false,
    }
    return newContributors
  }, {})
}
